
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"56","height":"56","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"id":"id-10a","width":"146.7%","height":"138.9%","x":"-23.3%","y":"-13.9%","filterUnits":"objectBoundingBox"}},[_c('feOffset',{attrs:{"dy":"2","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"in":"shadowOffsetOuter1","result":"shadowBlurOuter1","stdDeviation":"2"}}),_c('feColorMatrix',{attrs:{"in":"shadowBlurOuter1","values":"0 0 0 0 0 0 0 0 0 0.36180933 0 0 0 0 0.0307196601 0 0 0 0.24341674 0"}})]),_c('path',{attrs:{"id":"id-11b","d":"M43 24.18V13.414S33.037 12 28.029 12C23.037 12 13 13.414 13 13.414V24.18c.054 9.96 5.804 19.056 15.029 23.82C37.272 43.236 43 34.14 43 24.18z"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"28","cy":"28","r":"28","fill":"#53CB72"}}),_c('use',{attrs:{"fill":"#000","filter":"url(#id-10a)","xlink:href":"#id-11b"}}),_c('use',{attrs:{"fill":"#FFF","xlink:href":"#id-11b"}}),_c('path',{attrs:{"fill":"#61CB6A","fill-rule":"nonzero","d":"M28 17a1 1 0 011 1v6.999L36 25a1 1 0 01.993.883L37 26a1 1 0 01-1 1l-7-.001V34a1 1 0 01-.883.993L28 35a1 1 0 01-1-1v-7h-7a1 1 0 01-.993-.883L19 26a1 1 0 011-1h7v-7a1 1 0 01.883-.993z"}})])])
          )
        }
      }
    